import React from 'react';
import styled from "styled-components";

const LodingBackground  = styled.div`
    z-index: ${background => background ? '200' : ''};
    background-color: ${background => background ? ' rgba(0,0,0,0.4)' : ''};
` ;

function Loading({background, full}) {
    return (
        <>

            <div className={` ${background ? 'drawer-background':''}  ${full? 'fixed w-full h-full left-0 top-0' :''}`}>
                <div className={` ${full ? 'spinner-full' : 'spinner'}`}></div>
                <button className={` ${full ? 'loading-text-full' : 'loading-text'}`}>Loading...</button>
            </div>
        </>
    );
}

export default Loading;
